import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_GM_REPORT, GET_GM_REPORT_SUCCESS, GET_GM_REPORT_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getGmReport({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/get-gm-reports`,
      // url: `https://eog4fzrw57pebfl.m.pipedream.net/admin/get-gm-reports`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response?.status === 200) {
      yield put({
        type: GET_GM_REPORT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GM_REPORT_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GM_REPORT_ERROR, payload: error });
  }
}

export function* watchGetGmReport() {
  yield takeEvery(GET_GM_REPORT, getGmReport);
}

function* getGmReportSaga() {
  yield all([fork(watchGetGmReport)]);
}

export default getGmReportSaga;
